<template>
  <div class="coverShow" v-show="viseable">
    <div class="container-gj" @click="cancelClick">
      <div class="container-gd">
        <div class="modal-content" @click.stop>
          <div class="header-view">
            <span
              style="
                font-size: 18px;
                font-weight: 600;
                color: #2b2f36;
                line-height: 24px;
              "
              >考试时长设置</span
            >
            <img
              src="https://ossfastmake.mustke.com/qrCode/tupian/1736759941513.png"
              @click="cancelClick"
              style="width: 13px; height: 13px; cursor: pointer"
            />
          </div>
          <div class="body-view">
            <div style="display: flex; align-items: center; margin-top: 10px">
              <div
                class="input-container"
                style="flex: 1; margin-top: 0"
                :style="{
                  border: isFocus
                    ? '1px solid rgba(58,96,255,0.5)'
                    : '1px solid #DCDDE0',
                }"
              >
                <input
                  placeholder="时长"
                  type="number"
                  maxlength="4"
                  v-model="localTime"
                  class="input-container-input"
                  @focus="isFocus = true"
                  @blur="isFocus = false"
                  @input="handleInput"
                />
              </div>
              <div
                style="
                  font-size: 15px;
                  color: #2b2f36;
                  margin-left: 15px;
                  width: 32px;
                "
              >
                分钟
              </div>
            </div>
            <div
              style="
                height: 20px;
                font-size: 14px;
                font-weight: 500;
                text-align: left;
                color: #7f8390;
                line-height: 20px;
                margin-top: 10px;
              "
            >
              输入0为不限制，限制最大1000分钟
            </div>
          </div>
          <div class="btn-view">
            <div class="cancel" @click="cancelClick">取消</div>
            <div class="confirm" @click="confirmClick">确定</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SettingTimes",
  props: {
    showDialog: {
      type: Boolean,
      default: false,
    },
    time: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      isFocus: false,
      localTime: 0,
      viseable: false,
    };
  },
  watch: {
    showDialog(newVal) {
      console.log("iei21u92r2109ry29r0y2r021yr1209ry021");

      this.viseable = newVal;
    },
    time: {
      handler(newVal) {
        this.localTime = newVal;
      },
      immediate: true,
    },
  },
  methods: {
    close() {
      this.$emit("close");
    },
    cancelClick() {
      this.$emit("close");
    },
    confirmClick() {
      if (this.localTime === "") {
        this.showToast("请输入考试时长");
      } else {
        this.$emit("close");
        this.$emit("confirm", parseInt(this.localTime));
      }
    },
    handleInput() {
      if (this.localTime > 1000) {
        this.localTime = 1000;
      }
    },
    showToast(message) {
      // 简单的 toast 实现
      const toast = document.createElement("div");
      toast.style.position = "fixed";
      toast.style.top = "50%";
      toast.style.left = "50%";
      toast.style.transform = "translate(-50%, -50%)";
      toast.style.backgroundColor = "rgba(0, 0, 0, 0.7)";
      toast.style.color = "white";
      toast.style.padding = "10px 20px";
      toast.style.borderRadius = "4px";
      toast.style.zIndex = "9999";
      toast.textContent = message;
      document.body.appendChild(toast);

      setTimeout(() => {
        document.body.removeChild(toast);
      }, 2000);
    },
  },
};
</script>

<style lang="scss" scoped>
.coverShow {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 100;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.container-gj {
  position: fixed;
  top: 50%;
  left: 50%;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.65);
  z-index: 100;
  transform: translate(-50%, -50%);
}

.container-gd {
  /* padding: 17px 28px; */
  position: fixed;
  top: 50%;
  left: 50%;
  width: 400px;
  /* height: 600px; */
  background: #ffffff;
  z-index: 100;
  transform: translate(-50%, -50%);
  overflow: hidden;
  border-radius: 10px;
}

.container-gd::-webkit-scrollbar {
  display: none;
}

.modal-content {
  width: 100%;
  background-color: white;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.bg-view {
  width: 100%;
  padding: 0 12px;
  box-sizing: border-box;
}

.header-view {
  width: 100%;
  height: 59px;
  background-color: #ffffff;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #e7e7e7;
  padding: 0 12px;
  box-sizing: border-box;
}

.body-view {
  width: 100%;
  padding: 12px;
  box-sizing: border-box;
}

.input-container {
  height: 40px;
  border: 1px solid #dcdde0;
  border-radius: 4px;
  padding: 0 12px;
  box-sizing: border-box;
}

.input-container-input {
  width: 100%;
  height: 100%;
  border: none;
  outline: none;
  font-size: 14px;
}

.btn-view {
  display: flex;
  justify-content: space-between;
  padding: 12px;
  border-top: 1px solid #e7e7e7;
}

.cancel {
  width: 48%;
  height: 44px;
  line-height: 44px;
  text-align: center;
  border: 1px solid #3a60ff;
  border-radius: 4px;
  color: #3a60ff;
  cursor: pointer;
}

.confirm {
  width: 48%;
  height: 44px;
  line-height: 44px;
  text-align: center;
  background-color: #3a60ff;
  border-radius: 4px;
  color: white;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/SettingTimes/SettingTimes.vue